var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 44.13",
    style: {
      enableBackground: "new 0 0 50 44.13"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M49.59,39.55L27.63,1.53c-1.17-2.03-4.11-2.03-5.28,0L0.39,39.55c-1.17,2.03,0.29,4.58,2.64,4.58h43.91 C49.29,44.13,50.76,41.59,49.59,39.55z M22.51,12.46c0-1.37,1.11-2.48,2.48-2.48s2.48,1.11,2.48,2.48v15.28 c0,1.37-1.11,2.48-2.48,2.48s-2.48-1.11-2.48-2.48V12.46z M24.99,39.68c-1.82,0-3.3-1.48-3.3-3.3c0-1.82,1.48-3.3,3.3-3.3 s3.3,1.48,3.3,3.3C28.29,38.2,26.81,39.68,24.99,39.68z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "warning.e1fa47eb1be2d15fd540fc9b45e73e7b.svg";
export { ForwardRef as ReactComponent };